import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WaterLoginEventService {
  private waterLoginSubject = new Subject<string>();
  private waterLogoutSubject = new Subject<string>();
  onLogin$ = this.waterLoginSubject.asObservable();
  onLogout$ = this.waterLogoutSubject.asObservable();
  emitLogin() {
    this.waterLoginSubject.next();
  }
  emitLogout() {
    this.waterLogoutSubject.next();
  }
}